import { $ } from '@situation/setdesign.util';
import Isotope from 'isotope-layout';

$(window).on('load', () => {
    const mediaTiles = document.querySelector('.media-masonry');
    if (mediaTiles && typeof Isotope !== 'undefined') {
        // eslint-disable-next-line no-new
        new Isotope(mediaTiles, {
            layoutMode: 'masonry',
            itemSelector: '.media-masonry__item',
            percentPosition: true,
            masonry: { columnWidth: '.media-masonry__item', horizontalOrder: false },
        });

        mediaTiles.classList.add('media-masonry--loaded');
    }
});
